import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';
import { default as __ } from '../../../utils';
import { colors } from '../../../styles';
import { useCustomizer } from './context';

const PowerBarVertical = ({ power, xndxx }) => {
  const { actions } = useCustomizer();
  const [isDragging, setDragging] = useState(false);
  const [selected, setSelected] = useState(power);

  const config = {
    min: 19,
    mid: 100,
    max: 200,
    threshold: 20,
    shadeA: colors.ultrapurple,
    shadeB: colors.purple,
    shadeC: colors.accent,
  };

  const yInput = [config.min, config.max];
  const origin = useMotionValue(power);

  const radius = useTransform(origin, yInput, ['2px', '6px']);
  const mark = useTransform(origin, yInput, [config.shadeB, config.shadeC]);

  const bg = useTransform(origin, yInput, [config.shadeA, config.shadeB]);

  // drag stuff
  const position = delta => {
    __.callAll(
      origin.set(
        origin.get() - delta.y >= config.max
          ? config.max
          : origin.get() - delta.y <= config.min
          ? config.min
          : origin.get() - delta.y,
      ),
      setSelected(origin.get() - delta.y),
    );
  };

  const update = () => {
    const power = __.roundTo(selected, 0);
    const power_to_string =
      power < config.mid ? 'low' : power >= config.max - 20 ? 'top' : 'same';
    __.callAll(
      actions.updatePlayers(xndxx, 'power', power),
      actions.updatePlayers(xndxx, 'level', power_to_string),
    );
  };

  return (
    <>
      <motion.div
        className="border-radius"
        style={{
          backgroundColor: bg,
          width: '44px',
          height: `${config.max}px`,
          borderRadius: radius,
          position: 'relative',
        }}
      >
        <motion.div
          whileTap={{ scale: 1.1 }}
          drag="y"
          dragConstraints={{ top: 0, bottom: 0 }}
          dragElastic={0}
          dragTransition={{
            bounceStiffness: 300,
            timeConstant: 200,
            power: 0.2,
            bounceDamping: 10,
          }}
          dragMomentum={false}
          style={{
            borderRadius: radius,
            position: 'absolute',
            bottom: 0,
            width: '44px',
            height: origin,
            backgroundColor: mark,
          }}
          onDrag={(e, { delta }) => {
            if (isDragging) {
              position(delta);
            }
            return !isDragging;
          }}
          onDragStart={() => setDragging(true)}
          onDragEnd={() => {
            __.callAll(setDragging(false), update());
          }}
        />
      </motion.div>
    </>
  );
};

export default PowerBarVertical;
